'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;
exports.createListing = createListing;
exports.clearError = clearError;
exports.loadTrips = loadTrips;
exports.loadListing = loadListing;
exports.loadConfigs = loadConfigs;
exports.setTripField = setTripField;
exports.removeTripField = removeTripField;
exports.updateListing = updateListing;
exports.toggleCondition = toggleCondition;
exports.uploadImage = uploadImage;
exports.uploadCoverImage = uploadCoverImage;
exports.deleteTrip = deleteTrip;
exports.duplicateListing = duplicateListing;
exports.requestPhotographer = requestPhotographer;
exports.submitListing = submitListing;
exports.validateField = validateField;
exports.validateListing = validateListing;
exports.visitPage = visitPage;
exports.autoToggleTicket = autoToggleTicket;
exports.multipleToggle = multipleToggle;
exports.uploadCardImage = uploadCardImage;
exports.clearCardImage = clearCardImage;
exports.uploadHomeCookingImage = uploadHomeCookingImage;

var _immutable = require('immutable');

var _media = require('utils/media');

var _listing = require('utils/listing');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _trip = require('utils/trip');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_momentTimezone2.default.tz.setDefault('Asia/Bangkok');

var LOAD_LISTING = 'redux-frontend/listing/LOAD_LISTING';
var LOAD_LISTING_SUCCESS = 'redux-frontend/listing/LOAD_LISTING_SUCCESS';
var LOAD_LISTING_FAIL = 'redux-frontend/listing/LOAD_LISTING_FAIL';
var UPDATE_LISTING = 'redux-frontend/listing/UPDATE_LISTING';
var UPDATE_LISTING_SUCCESS = 'redux-frontend/listing/UPDATE_LISTING_SUCCESS';
var UPDATE_LISTING_FAIL = 'redux-frontend/listing/UPDATE_LISTING_FAIL';

var LOAD_TRIPS = 'redux-frontend/listing/LOAD_TRIPS';
var LOAD_TRIPS_SUCCESS = 'redux-frontend/listing/LOAD_TRIPS_SUCCESS';
var LOAD_TRIPS_FAIL = 'redux-frontend/listing/LOAD_TRIPS_FAIL';
var LOAD_CONFIG = 'redux-frontend/listing/LOAD_CONFIG';
var LOAD_CONFIG_SUCCESS = 'redux-frontend/listing/LOAD_CONFIG_SUCCESS';
var LOAD_CONFIG_FAIL = 'redux-frontend/listing/LOAD_CONFIG_FAIL';
var UPLOAD_IMAGE = 'redux-frontend/listing/UPLOAD_IMAGE';
var UPLOAD_IMAGE_SUCCESS = 'redux-frontend/listing/UPLOAD_IMAGE_SUCCESS';
var UPLOAD_IMAGE_FAIL = 'redux-frontend/listing/UPLOAD_IMAGE_FAIL';
var UPLOAD_CARD_IMAGE = 'redux-frontend/listing/UPLOAD_CARD_IMAGE';
var UPLOAD_CARD_IMAGE_SUCCESS = 'redux-frontend/listing/UPLOAD_CARD_IMAGE_SUCCESS';
var UPLOAD_CARD_IMAGE_FAIL = 'redux-frontend/listing/UPLOAD_CARD_IMAGE_FAIL';
var CLEAR_CARD_IMAGE = 'redux-frontend/listing/CLEAR_CARD_IMAGE';

var SET_TRIP_FIELD = 'redux-frontend/listing/SET_TRIP_FIELD';
var REMOVE_TRIP_FIELD = 'redux-frontend/listing/REMOVE_TRIP_FIELD';
var TOGGLE_CONDITION = 'redux-frontend/listing/TOGGLE_CONDITION';

var CREATE_LISTING = 'redux-frontend/listing/CREATE_LISTING';
var CREATE_LISTING_SUCCESS = 'redux-frontend/listing/CREATE_LISTING_SUCCESS';
var CREATE_LISTING_FAIL = 'redux-frontend/listing/CREATE_LISTING_FAIL';

var CLEAR_ERROR = 'redux-frontend/listing/CLEAR_ERROR';

var DELETE_TRIP = 'redux-frontend/listing/DELETE_TRIP';
var DELETE_TRIP_SUCCESS = 'redux-frontend/listing/DELETE_TRIP_SUCCESS';
var DELETE_TRIP_FAIL = 'redux-frontend/listing/DELETE_TRIP_FAIL';

var SUBMIT_LISTING = 'redux-frontend/listing/SUBMIT_LISTING';
var SUBMIT_LISTING_SUCCESS = 'redux-frontend/listing/SUBMIT_LISTING_SUCCESS';
var SUBMIT_LISTING_FAIL = 'redux-frontend/listing/SUBMIT_LISTING_FAIL';

var DUPLICATE_LISTING = 'redux-frontend/listing/DUPLICATE_LISTING';
var DUPLICATE_LISTING_SUCCESS = 'redux-frontend/listing/DUPLICATE_LISTING_SUCCESS';
var DUPLICATE_LISTING_FAIL = 'redux-frontend/listing/DUPLICATE_LISTING_FAIL';
var VALIDATE_FIELD = 'redux-frontend/listing/VALIDATE_FIELD';
var VALIDATE_LISTING = 'redux-frontend/listing/VALIDATE_LISTING';

var VISIT_PAGE = 'redux-frontend/listing/VISIT_PAGE';

var REQUEST_PHOTO = 'redux-frontend/listing/REQUEST_PHOTO';
var REQUEST_PHOTO_SUCCESS = 'redux-frontend/listing/REQUEST_PHOTO_SUCCESS';
var REQUEST_PHOTO_FAIL = 'redux-frontend/listing/REQUEST_PHOTO_FAIL';

var AUTO_TOGGLE_TICKET = 'redux-frontend/listing/AUTO_TOGGLE_TICKET';
var MULTIPLE_TOGGLE = 'redux-frontend/listing/MULTIPLE_TOGGLE';

var UPLOAD_IMAGE_HOME_COOKING = 'redux-frontend/listing/UPLOAD_IMAGE_HOME_COOKING';
var UPLOAD_IMAGE_HOME_COOKING_SUCCESS = 'redux-frontend/listing/UPLOAD_IMAGE_HOME_COOKING_SUCCESS';
var UPLOAD_IMAGE_HOME_COOKING_FAIL = 'redux-frontend/listing/UPLOAD_IMAGE_HOME_COOKING_FAIL';

var UPLOAD_COVER_PHOTO = 'redux-frontend/listing/UPLOAD_COVER_PHOTO_PHOTO';
var UPLOAD_COVER_PHOTO_SUCCESS = 'redux-frontend/listing/UPLOAD_COVER_PHOTO_SUCCESS';
var UPLOAD_COVER_PHOTO_FAIL = 'redux-frontend/listing/UPLOAD_COVER_PHOTO_FAIL';

var initialstate = {
  configs: {},
  listing: {},
  trips: [],
  creating: false,
  loaded: false,
  loadedListing: false,
  submitting: false,
  saving: false,
  duplicating: false,
  dirty: false,
  warning: { basic: false, overview: false, detail: false, conditions: false },
  fieldError: {},
  visitedPage: -1,
  uploadingCoverImage: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialstate;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var images = void 0;
  switch (action.type) {
    case CREATE_LISTING:
      return (0, _extends4.default)({}, state, {
        creating: true
      });
    case CREATE_LISTING_SUCCESS:
      return (0, _extends4.default)({}, state, {
        error: null,
        creating: false
      });
    case CREATE_LISTING_FAIL:
      return (0, _extends4.default)({}, state, {
        error: action.error,
        creating: false
      });
    case CLEAR_ERROR:
      return (0, _extends4.default)({}, state, {
        fieldError: {},
        warning: { basic: false, overview: false, detail: false, conditions: false }
      });
    case DUPLICATE_LISTING:
      return (0, _extends4.default)({}, state, {
        duplicating: true
      });
    case DUPLICATE_LISTING_SUCCESS:
      return (0, _extends4.default)({}, state, {
        duplicating: false
      });
    case DUPLICATE_LISTING_FAIL:
      return (0, _extends4.default)({}, state, {
        duplicating: false
      });
    case LOAD_LISTING:
      return (0, _extends4.default)({}, state, {
        loadingListing: true
      });
    case LOAD_LISTING_SUCCESS:
      var listing = action.result;
      var configs = state.configs;

      if (listing.itinerary.length < 3) {
        listing.itinerary = [].concat((0, _toConsumableArray3.default)(listing.itinerary), (0, _toConsumableArray3.default)(_lodash2.default.fill(Array(3 - listing.itinerary.length), { time: '', text: '' })));
      }
      listing.itinerary = listing.itinerary.map(function (it) {
        return (0, _extends4.default)({}, it, { id: Math.random().toString(36).substring(7) });
      }); // gen id for drag n drop
      configs.faqs.map(function (faq) {
        // Sometime configs haven't load yet
        if (!_lodash2.default.find(listing.faqs, { question: faq.question })) {
          listing.faqs.push({ question: faq.question, answer: '', sub: faq.sub, example: faq.example });
        } else {
          // remove this
          var faqIndex = listing.faqs.findIndex(function (f) {
            return f.question === faq.question;
          });
          listing.faqs[faqIndex] = (0, _extends4.default)({}, listing.faqs[faqIndex], {
            sub: faq.sub,
            example: faq.example
          });
        }
      });
      if ((0, _listing.prepPhotographDates)(listing.photograph_dates).length > 0) {
        // deprecated
        listing.request_photographer = true;
      } else {
        listing.request_photographer = false;
        listing.photograph_dates = [''];
      }
      if (listing.product_type === 'ticket') {
        var customTime = listing.custom_hotel_time || [];
        var start = customTime.length === 0 ? '09:00' : customTime[0];
        var end = customTime.length === 0 ? '17:00' : customTime[customTime.length - 1];
        listing.custom_hotel_pickup_start = start;
        listing.custom_hotel_pickup_end = end;
      }
      return (0, _extends4.default)({}, state, {
        loadingListing: false,
        loadedListing: true,
        listing: (0, _immutable.Map)(listing),
        warnings: [false, false, false, false, false],
        dirty: false,
        error: null
      });
    case LOAD_LISTING_FAIL:
      return (0, _extends4.default)({}, state, {
        loadingListing: false,
        loadedListing: false,
        listing: (0, _immutable.Map)({}),
        error: action.error
      });
    case UPDATE_LISTING:
      return (0, _extends4.default)({}, state, {
        saving: true
      });
    case UPDATE_LISTING_SUCCESS:
      return (0, _extends4.default)({}, state, {
        saving: false,
        dirty: false,
        error: null
      });
    case UPDATE_LISTING_FAIL:
      return (0, _extends4.default)({}, state, {
        saving: false,
        error: action.error
      });
    case LOAD_TRIPS:
      return (0, _extends4.default)({}, state, {
        loading: true
      });
    case LOAD_TRIPS_SUCCESS:
      return (0, _extends4.default)({}, state, {
        loading: false,
        trips: action.result,
        error: null
      });
    case LOAD_TRIPS_FAIL:
      return (0, _extends4.default)({}, state, {
        loading: false,
        trips: [],
        error: action.error
      });
    case LOAD_CONFIG:
      return (0, _extends4.default)({}, state, {
        loading: true
      });
    case LOAD_CONFIG_SUCCESS:
      return (0, _extends4.default)({}, state, {
        loading: false,
        configs: action.result,
        error: null
      });
    case LOAD_CONFIG_FAIL:
      return (0, _extends4.default)({}, state, {
        loading: false,
        configs: {},
        error: action.error
      });
    case REQUEST_PHOTO_SUCCESS:
      return (0, _extends4.default)({}, state, {
        listing: state.listing.set('is_photographer_requested', true)
      });
    case SET_TRIP_FIELD:
      return (0, _extends4.default)({}, state, {
        dirty: action.dirty,
        listing: state.listing.set(action.name, action.value)
      });
    case REMOVE_TRIP_FIELD:
      return (0, _extends4.default)({}, state, {
        dirty: action.dirty,
        listing: state.listing.delete(action.name)
      });
    case SUBMIT_LISTING:
      return (0, _extends4.default)({}, state, {
        submitting: true
      });
    case SUBMIT_LISTING_SUCCESS:
      return (0, _extends4.default)({}, state, {
        submitting: false,
        error: false
      });
    case SUBMIT_LISTING_FAIL:
      return (0, _extends4.default)({}, state, {
        submitting: false,
        error: true
      });
    case TOGGLE_CONDITION:
      var conditions = state.listing.get('conditions');
      if (!conditions) {
        conditions = [];
      }
      if (conditions.indexOf(action.key) < 0) {
        conditions.push(action.key);
      } else {
        conditions.splice(conditions.indexOf(action.key), 1);
      }
      return (0, _extends4.default)({}, state, {
        listing: state.listing.set('conditions', conditions),
        dirty: true
      });
    case UPLOAD_IMAGE:
      images = state.listing.get('images');
      return (0, _extends4.default)({}, state, {
        listing: state.listing.set('images', images.concat([{ loading: true }]))
      });
    case UPLOAD_IMAGE_SUCCESS:
      images = _lodash2.default.clone(state.listing.get('images'));
      var loadingIndex = _lodash2.default.findIndex(images, function (image) {
        return image.loading;
      });
      images[loadingIndex] = { image: action.result, caption: '', loading: false };
      return (0, _extends4.default)({}, state, {
        listing: state.listing.set('images', images)
      });
    case UPLOAD_COVER_PHOTO:
      return (0, _extends4.default)({}, state, {
        uploadingCoverImage: true
      });
    case UPLOAD_COVER_PHOTO_SUCCESS:
      return (0, _extends4.default)({}, state, {
        uploadingCoverImage: false,
        listing: state.listing.set('cover_image', action.result)
      });
    case UPLOAD_COVER_PHOTO_FAIL:
      return (0, _extends4.default)({}, state, {
        uploadingCoverImage: false
      });
    case UPLOAD_CARD_IMAGE:
      return (0, _extends4.default)({}, state, {
        listing: state.listing.set('card_image', null)
      });
    case UPLOAD_CARD_IMAGE_SUCCESS:
      return (0, _extends4.default)({}, state, {
        listing: state.listing.set('card_image', action.result),
        dirty: true
      });
    case UPLOAD_IMAGE_HOME_COOKING:
      return (0, _extends4.default)({}, state, {
        listing: state.listing.set('home_cooking', (0, _extends4.default)({}, state.listing.get('home_cooking'), {
          images: [].concat((0, _toConsumableArray3.default)(state.listing.get('home_cooking').images), [{ loading: true }])
        }))
      });
    case UPLOAD_IMAGE_HOME_COOKING_SUCCESS:
      var homeCookingObj = _lodash2.default.clone(state.listing.get('home_cooking'));
      var loadingIdx = _lodash2.default.findIndex(homeCookingObj.images, function (image) {
        return image.loading;
      });
      homeCookingObj.images[loadingIdx] = { image: action.result, caption: '', loading: false };
      return (0, _extends4.default)({}, state, {
        listing: state.listing.set('home_cooking', homeCookingObj),
        dirty: true
      });
    case CLEAR_CARD_IMAGE:
      return (0, _extends4.default)({}, state, {
        listing: state.listing.set('card_image', null),
        dirty: true
      });
    case VALIDATE_FIELD:
      return (0, _extends4.default)({}, state, {
        fieldError: (0, _extends4.default)({}, state.fieldError, (0, _defineProperty3.default)({}, action.name, (0, _listing.checkFieldError)(action.name, action.value)))
      });
    case VALIDATE_LISTING:
      var _validateListingHelpe = (0, _listing.validateListingHelpers)(state.listing, action.index),
          warning = _validateListingHelpe.warning,
          fieldError = _validateListingHelpe.fieldError;

      return (0, _extends4.default)({}, state, {
        warning: (0, _extends4.default)({}, state.warning, warning),
        fieldError: (0, _extends4.default)({}, state.fieldError, fieldError)
      });
    case VISIT_PAGE:
      return (0, _extends4.default)({}, state, {
        visitedPage: action.page
      });
    case AUTO_TOGGLE_TICKET:
      return (0, _extends4.default)({}, state, {
        listing: state.listing.set('is_date_not_required', action.toggle).set('is_message_disabled', action.toggle).set('is_redeem_inapplicable', action.toggle).set('is_hide_summary', action.toggle).set('is_hide_faq', action.toggle).set('is_hide_trip_detail', action.toggle).set('is_hide_itinerary', action.toggle).set('is_hide_price_condition', action.toggle).set('is_hide_meeting_point', action.toggle).set('is_hide_review', action.toggle)
      });
    case MULTIPLE_TOGGLE:
      return (0, _extends4.default)({}, state, {
        listing: state.listing.merge(action.fields)
      });
    default:
      return state;
  }
}

function prepData(listing) {
  var itinerary = listing.get('itinerary');
  var meetingPoints = listing.get('meeting_points');
  var customLocations = listing.get('custom_locations') && listing.get('custom_locations').map(function (customLoc) {
    return {
      name: customLoc.name,
      location: {
        lat: Number(customLoc.location.lat),
        lon: Number(customLoc.location.lon)
      }
    };
  });
  var isAdvancePrice = listing.get('isAdvancePrice');
  var photographDates = listing.get('request_photographer') ? (0, _listing.prepPhotographDates)(listing.get('photograph_dates')) : [];
  if (!listing.get('is_custom_itinerary') || !itinerary[0].text) {
    itinerary[0].text = (0, _listing.getFirstItinerary)(meetingPoints);
  }
  var checkedItinerary = itinerary.reduce(function (prev, curr) {
    if (!curr.text && !curr.time) {
      return prev;
    }
    return [].concat((0, _toConsumableArray3.default)(prev), [curr]);
  }, []);
  var prices = listing.get('prices');
  var user = listing.get('user_id');
  if (isAdvancePrice) {
    prices = listing.get('advancePrice').map(function (price) {
      return (0, _trip.calculateTripPrice)(price, 1, user.is_travel_agency, user.travel_agency_commission);
    });
  } else {
    prices = _lodash2.default.fill(Array(listing.get('max_travelers')), (0, _trip.calculateTripPrice)(listing.get('basicPrice'), 1, user.is_travel_agency, user.travel_agency_commission));
  }
  var additionalOptions = listing.get('additional_options');
  var childPrice = additionalOptions.find(function (o) {
    return o.key === 'children';
  });
  if (!!childPrice) {
    additionalOptions = additionalOptions.map(function (o) {
      if (o.key === 'children') {
        var price = (0, _trip.calculateTripPrice)(o.price, 1, user.is_travel_agency, user.travel_agency_commission);
        return (0, _extends4.default)({}, o, { lx_price: price, price: price });
      }
      return o;
    });
  }
  var customHotelPickupTime = [];
  if (listing.get('product_type') === 'ticket') {
    var start = listing.get('custom_hotel_pickup_start');
    var end = listing.get('custom_hotel_pickup_end');
    var startDate = (0, _momentTimezone2.default)(start, 'HH:mm');
    var endDate = (0, _momentTimezone2.default)(end, 'HH:mm');
    customHotelPickupTime = _lodash2.default.range(0, Math.abs(startDate.diff(endDate, 'hours')) + 1).map(function (hr) {
      return startDate.clone().add(hr, 'hour').format('HH:mm');
    });
  }
  return listing.set('_id', undefined).set('itinerary', checkedItinerary).set('photograph_dates', photographDates).set('price_condition', (0, _extends4.default)({}, listing.get('price_condition'), { enabled_icons: listing.get('price_condition').enabled_icons || [] })).set('custom_locations', customLocations).set('additional_options', additionalOptions).set('custom_hotel_time', customHotelPickupTime).set('prices', prices).toJS();
}

function createListing() {
  return {
    types: [CREATE_LISTING, CREATE_LISTING_SUCCESS, CREATE_LISTING_FAIL],
    promise: function promise(client) {
      return client.post('/listings');
    }
  };
}

function clearError() {
  return {
    type: CLEAR_ERROR
  };
}

function loadTrips() {
  return {
    types: [LOAD_TRIPS, LOAD_TRIPS_SUCCESS, LOAD_TRIPS_FAIL],
    promise: function promise(client) {
      return client.get('/listings?limit=0');
    }
  };
}

function loadListing(id) {
  return {
    types: [LOAD_LISTING, LOAD_LISTING_SUCCESS, LOAD_LISTING_FAIL],
    promise: function promise(client) {
      return client.get('/listings/' + id);
    }
  };
}

function loadConfigs() {
  return {
    types: [LOAD_CONFIG, LOAD_CONFIG_SUCCESS, LOAD_CONFIG_FAIL],
    promise: function promise(client) {
      return client.get('/listings/configs');
    }
  };
}

function setTripField(name, value) {
  var dirty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  return {
    type: SET_TRIP_FIELD,
    name: name,
    value: value,
    dirty: dirty
  };
}

function removeTripField(name) {
  var dirty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return {
    type: REMOVE_TRIP_FIELD,
    name: name,
    dirty: dirty
  };
}

function updateListing(id, listing) {
  var hideToast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var data = prepData(listing);
  return {
    types: [UPDATE_LISTING, UPDATE_LISTING_SUCCESS, UPDATE_LISTING_FAIL],
    promise: function promise(client) {
      return client.put('/listings/' + id, { data: data }).then(function (res) {
        if (data.request_photographer && !res.is_photographer_requested) {
          client.post('/listings/' + res._id + '/request-photographer');
        }
        return res;
      });
    },
    hideToast: hideToast
  };
}

function toggleCondition(key) {
  return {
    type: TOGGLE_CONDITION,
    key: key
  };
}

function uploadImage(file) {
  return {
    types: [UPLOAD_IMAGE, UPLOAD_IMAGE_SUCCESS, UPLOAD_IMAGE_FAIL],
    promise: function promise() {
      return (0, _media.upload)(file, 'trips');
    }
  };
}

function uploadCoverImage(file) {
  return {
    types: [UPLOAD_COVER_PHOTO, UPLOAD_COVER_PHOTO_SUCCESS, UPLOAD_COVER_PHOTO_FAIL],
    promise: function promise() {
      return (0, _media.upload)(file, 'trips');
    }
  };
}

function deleteTrip(tripId) {
  return {
    types: [DELETE_TRIP, DELETE_TRIP_SUCCESS, DELETE_TRIP_FAIL],
    promise: function promise(client) {
      return client.del('/listings/' + tripId);
    }
  };
}

function duplicateListing(id, listing) {
  var data = prepData(listing);
  return {
    types: [DUPLICATE_LISTING, DUPLICATE_LISTING_SUCCESS, DUPLICATE_LISTING_FAIL],
    promise: function promise(client) {
      return client.post('/listings/' + id + '/duplicate', { data: data }).then(function (res) {
        if (data.request_photographer && !res.is_photographer_requested) {
          client.post('/listings/' + res._id + '/request-photographer');
        }
        return res;
      });
    }
  };
}

function requestPhotographer(listingId) {
  return {
    types: [REQUEST_PHOTO, REQUEST_PHOTO_SUCCESS, REQUEST_PHOTO_FAIL],
    promise: function promise(client) {
      return client.post('/listings/' + listingId + '/request-photographer');
    }
  };
}

function submitListing(listingId) {
  return {
    types: [SUBMIT_LISTING, SUBMIT_LISTING_SUCCESS, SUBMIT_LISTING_FAIL],
    promise: function promise(client) {
      return client.post('/listings/' + listingId + '/submit');
    }
  };
}

function validateField(name, value) {
  return {
    type: VALIDATE_FIELD,
    name: name,
    value: value
  };
}

function validateListing(index) {
  return {
    type: VALIDATE_LISTING,
    index: index
  };
}

function visitPage(page) {
  return {
    type: VISIT_PAGE,
    page: page
  };
}

function autoToggleTicket(toggle) {
  return {
    type: AUTO_TOGGLE_TICKET,
    toggle: toggle
  };
}

function multipleToggle(fields) {
  return {
    type: MULTIPLE_TOGGLE,
    fields: fields
  };
}

function uploadCardImage(file) {
  return {
    types: [UPLOAD_CARD_IMAGE, UPLOAD_CARD_IMAGE_SUCCESS, UPLOAD_CARD_IMAGE_FAIL],
    promise: function promise() {
      return (0, _media.upload)(file, 'trips');
    }
  };
}

function clearCardImage() {
  return {
    type: CLEAR_CARD_IMAGE
  };
}

function uploadHomeCookingImage(file) {
  return {
    types: [UPLOAD_IMAGE_HOME_COOKING, UPLOAD_IMAGE_HOME_COOKING_SUCCESS, UPLOAD_IMAGE_HOME_COOKING_FAIL],
    promise: function promise() {
      return (0, _media.upload)(file, 'trips');
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/listing.js
// module id = 71
// module chunks = 47